import HomeComponent from '@/components/pages/Home'
import type { NextPage } from 'next'
import { GetServerSideProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'

// Libs
import { fetchHomeSectionOrder } from '@/api/fetchHomeSectionOrder'

// Components

// Constants
import { getVisibleHomeSections, HomeSectionKey } from '@/constants/homeSection'

// Styles

// Variables

interface IHomePageProps {
  sections: HomeSectionKey[]
}

// _app（components/pages/App）以 <Component {...appProps} /> 渲染頁面，getServerSideProps 的資料在 props.pageProps 裡
const Home: NextPage<{ pageProps?: IHomePageProps }> = ({ pageProps }) => {
  const sections = pageProps?.sections
  return (
    <>
      <Head>
        <title>{'TutorABC Shop'}</title>
      </Head>
      <HomeComponent sections={sections} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps<IHomePageProps> = async ({ locale }) => {
  // 取不到設定（API 失敗、尚未設定）就用預設順序，不擋首頁
  let sectionOrderParams = null
  try {
    sectionOrderParams = (await fetchHomeSectionOrder({ ssrLocale: locale })).params
  } catch (error) {
    console.log('fetchHomeSectionOrder Error', error)
  }

  return {
    props: {
      ...(await serverSideTranslations(locale as string, ['common'])),
      sections: getVisibleHomeSections(sectionOrderParams),
    },
  }
}

export default Home
